module.exports = __webpack_public_path__ + "img/iphone8.cec97b64.jpg";